import { loader } from 'graphql.macro'

export default async function deleteAssetFromSite ({ dataLoaders, variables }) {
  const schema = loader('./deleteAssetFromSite.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      assetId: variables.assetId,
      setOnSelf: variables.setOnSelf
    }
  })
  return response.deleteAssetFromSite
}
